module.exports = "https://trybtryb-legacy.web.app/img/shadow-bottom-special-desktop.24a73e96.svg";